import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { DocumentScreen } from 'screens/patient';

export default withPermissions(DocumentScreen, [
  GroupSecurity.DocumentReferenceRead,
]);
